import { AirportCodes } from '../../../types/airports';
import { PageRoutes } from '../../app/pages/domain/constants/PageRoutes';
import WhereWeFlyLogo from '../../../assets/where-we-fly-logo.svg';
import SpaceportLogo from '../../../assets/airport-logos/spaceport-logo.svg';

export const sectionLinks = [
	{
		id: AirportCodes.IAH,
		code: AirportCodes.IAH,
		label: 'George Bush Intercontinental Airport',
		href: PageRoutes.IAHHome,
	},
	{
		id: AirportCodes.HOU,
		code: AirportCodes.HOU,
		label: 'William P. Hobby Airport',
		href: PageRoutes.HOUHome,
	},
	{
		id: 'explore-destinations',
		label: 'Explore Destinations',
		icon: <WhereWeFlyLogo aria-label="Plane icon" />,
		href: PageRoutes.IAHExploreDestinations,
	},
	{
		id: AirportCodes.EFD,
		code: AirportCodes.EFD,
		label: 'Ellington Airport',
		href: PageRoutes.EFDHome,
	},
	{
		id: AirportCodes.Spaceport,
		code: AirportCodes.Spaceport,
		label: 'Houston Spaceport',
		icon: <SpaceportLogo />,
		href: PageRoutes.SpaceportHome,
	},
];
